module.exports = __webpack_public_path__ + "img/653-5d79c4.png";